import React from 'react';
import styles from './no-data.module.scss';

const NoData = ({ noData, noContent }) => {
  return (
    <div className={styles.noDataSection}>
      <div>
        <span className={styles.noDataFontSize}>{noData}</span>
      </div>
      <div className={styles.marginT}>
        <span>{noContent}</span>
      </div>
    </div>
  );
};

export { NoData };
